import { Box, Typography } from '@forgeglobal/design-framework';
import { useStyles } from './style';

interface AssetValuationsGreetingProps {
  isUserRMD: boolean;
}

export const AssetValuationsGreeting = ({
  isUserRMD,
}: AssetValuationsGreetingProps) => {
  const classes = useStyles();
  const rmdInstruction = (
    <Typography variant="body1" className={classes.rmdText}>
      Since your account has reached Required Minimum Distribution (RMD) status,
      you will be required to upload additional documentation supporting the
      current valuation.
    </Typography>
  );
  return (
    <Box className={classes.valuationGreetings}>
      <Typography variant="h6" className={classes.title}>
        Instructions
      </Typography>
      <Typography variant="body1">
        As a self-directed IRA owner, you are responsible for providing a
        current value for your below investment(s) on an annual basis.
      </Typography>
      {isUserRMD && rmdInstruction}
    </Box>
  );
};
